import LanguageIcon from "@mui/icons-material/Language";
import { MenuItem, Select, Stack } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

import { useSetLocale } from "../../lib/i18n/localeContext";
import { locales } from "../../lib/i18n/locales";

export const LanguageSwitcher: React.FC = () => {
    const setLocale = useSetLocale();
    const { locale } = useIntl();

    return (
        <Select
            size="small"
            value={locale}
            onChange={(e) => setLocale(e.target.value)}
            variant="outlined"
            renderValue={(value) => (
                <Stack direction="row" alignItems="center" gap={1}>
                    <LanguageIcon fontSize="small" sx={{ color: "text.textHelper" }} />
                    {locales.find((l) => l.code === value)?.label ?? value}
                </Stack>
            )}
            sx={{ minWidth: 130 }}
        >
            {locales.map((l) => (
                <MenuItem key={l.code} value={l.code}>
                    {l.label}
                </MenuItem>
            ))}
        </Select>
    );
};
